import Vue from 'vue';
import Router from 'vue-router';
import Root from './views/Root.vue';
import Chat from './views/chat/Chat.vue';
import Login from './views/user/Login.vue';
import AppContainer from './views/app/AppContainer.vue';

import Share from './views/user/Share.vue';

import store from './store';

Vue.use(Router);

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'Home',
			component: Root
		},
		{
			path: '/chat',
			name: 'Chat',
			meta: {
				requiresAuth: true
			},
			component: Chat
		},
		{
			path: '/share',
			name: 'Share',
			meta: {
				requiresAuth: true
			},
			component: Share
		},
		{
			path: '/about',
			name: 'About',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () =>
				import(/* webpackChunkName: "about" */ './views/About.vue')
		},
		{
			path: '/login',
			name: 'Login',
			component: Login
		},
		{
			path: '/app',
			name: 'Apps',
			component: AppContainer,
			//() => import('./views/app/AppContainer.vue'),
			children: [
				{
					path: '/minecraft',
					name: 'Minecraft',
					meta: {
						requiresAuth: true
					},
					component: () => import('./views/app/Minecraft.vue')
				},
				{
					path: '/steam',
					name: 'Steam',
					component: () => import('./views/app/Steam.vue')
				}
			]
		}
	]
});

router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.requiresAuth)) {
		// this route requires auth, check if logged in
		// if not, redirect to login page.
		// TODO if (!auth.loggedIn()) {
		if (!store.getters.isLoggedIn) {
			next({
				path: '/login',
				query: { redirect: to.fullPath }
			});
		} else {
			next();
		}
	} else {
		next(); // make sure to always call next()!
	}
});

export default router;
